import createDOMPurify, { WindowLike } from 'dompurify';

/**
 * Sanitizes the input to prevent XSS
 * @param input - The input that needs to be sanitized (string, array, or object)
 * @returns Sanitized input
 */
export function clientSanitizeInput<T>(input: T): T | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const DOMPurify = createDOMPurify(window as WindowLike);

  if (typeof input === 'string') {
    return DOMPurify.sanitize(input) as unknown as T;
  }

  if (typeof input === 'object' && input !== null) {
    const sanitized: Record<string, string> = {};

    for (const [key, value] of Object.entries(input)) {
      sanitized[key] = clientSanitizeInput(value);
    }

    return sanitized as T;
  }

  return input;
}
